@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackWorkflow {
  display: flex;
  flex-direction: column;
  color: var(--black);
  gap: 30px;

  .bigTitle {
    max-width: 900px;
    font-size: 28px;

    @include texts.font("semi-bold");
  }

  .columns {
    display: flex;
    flex-direction: column;
    gap: 25px;

    .column {
      display: flex;
      gap: 25px;

      .left {
        padding: 25px;
        background: var(--grey-sur);
        display: flex;
        flex-direction: column;
        gap: 30px;
        width: 30%;
        border-radius: 16px;

        .title {
          font-size: 20px;

          @include texts.font("semi-bold");
        }

        .content {
          display: flex;
          gap: 15px;

          .icon {
            height: 35px;
            width: 35px;
            flex: 0 0 35px;

            &.topics {
              @include icons.ico("colored-topical-map-ranked");
            }

            &.fire {
              filter: var(--icon-fire);

              @include icons.ico("black-fire");
            }

            &.fireBlack {
              @include icons.ico("black-fire");
            }

            &.chart {
              @include icons.ico("black-chart");
            }

            &.aiWriting {
              @include icons.ico("black-ai-writing");
            }

            &.aiWrite {
              @include icons.ico("black-ai-write");
            }
          }

          .description {
            font-size: 15px;
          }
        }

        .button {
          margin-top: auto;
          background: var(--black);
          color: var(--white);
          height: 44px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 15px;
          border-radius: 12px;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }

          .icon {
            height: 14px;
            width: 14px;
            filter: var(--icon-white);
            transform: rotate(315deg);

            @include icons.ico("black-right-arrow");
          }
        }
      }

      .right {
        width: 70%;
        background: var(--grey-sur);
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;

        .img {
          width: 100%;

          &.topicalMap {
            visibility: visible;
          }

          &.chart {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }

  @media screen and (max-width: 930px) {
    .bigTitle {
      font-size: 22px !important;
    }

    .left {
      width: calc(100% - 50px) !important;
    }

    .right {
      display: none !important;
    }
  }
}